import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ImageLazyLoader from 'components/common/ImageLazyLoader';
import { mobile as layoutCSS } from 'styles/components/productdetail/swatchPickerLayout.scss';
import css from 'styles/components/productdetail/mobileSwatchPicker.scss';

function convertThumbnail(src) {
  return src.replace('t-THUMBNAIL', 'p-MOBILETHUMB');
}

const makeThumbnailImage = ({ productStyles }, thumbnail) => {
  const imgProps = {
    'className': css.swatchThumbnail,
    'src': convertThumbnail(thumbnail.src),
    'alt': productStyles[thumbnail.styleId].color,
    'title': productStyles[thumbnail.styleId].color,
    'data-track-action': 'Product-Page',
    'data-track-label': 'PrImage',
    'data-track-value': 'Swatch'
  };
  const placeholder = <div className={css.swatchThumbnailPlaceholder} />;
  return <ImageLazyLoader imgProps={imgProps} placeholder={placeholder} />;
};

const makeThumbnailButton = (props, thumbnail) => {
  const { selectedStyleId, onStyleChange } = props;
  const buttonProps = {
    'key': thumbnail.styleId,
    'className': cn(
      css.thumbWrap,
      { [css.selectedSwatch]: selectedStyleId === thumbnail.styleId }
    ),
    'onClick': onStyleChange,
    'data-style-id': thumbnail.styleId
  };
  return <button type="button" {...buttonProps}>{makeThumbnailImage(props, thumbnail)}</button>;
};

const MobileSwatchPicker = (props, { testId }) => {
  const { thumbnails } = props;
  if (thumbnails && thumbnails.length && thumbnails.length > 1) {
    return (
      <div className={css.swatchPicker} data-test-id={testId('swatchPicker')}>
        <div className={layoutCSS}>
          {thumbnails.map(thumbnail => makeThumbnailButton(props, thumbnail))}
        </div>
      </div>
    );
  }
  return null;
};

MobileSwatchPicker.propTypes = {
  productStyles: PropTypes.object.isRequired,
  selectedStyleId: PropTypes.string.isRequired,
  onStyleChange: PropTypes.func.isRequired,
  thumbnails: PropTypes.arrayOf(PropTypes.object)
};

MobileSwatchPicker.contextTypes = {
  testId: PropTypes.func
};

export default MobileSwatchPicker;
